<template>
  <div>
    <b-overlay 
      :show="isLoading" 
      rounded="sm" 
      opacity="0.6" 
      spinner-small 
      spinner-variant="primary"
    >
    <nav class="custom-nav">
    <div class="custom-navbar">
      <div class="left-rectangle" id="left-rectangle">
        <div @click="navigateToHome">
          <img src="@/assets/imgs/logoDark.svg" class="img-fluid" alt="Logo Inventech" >
        </div>
        <div class="separator">|</div>
        <span class="text-black">
          {{ projectName || selectedProject?.name }}
        </span>    
        <div class="separator">|</div>
        <div @click="duplicateCurrentProject" v-b-tooltip.hover.top="$t('home.duplicate-project')">
          <img src="@/assets/imgs/iconDuplicated.svg" alt="icon-duplicated" width="24">
        </div>
        <div class="separator">|</div>
        <!-- BOTÓN UNDO -->
        <div
          @click="triggerUndo"
          v-b-tooltip.hover.buttom="$t('workspace.tooltip.back')"
          :class="{ 'disabled-icon': !canUndo }"
          class="undo-icon"
        >
          <img src="@/assets/imgs/undo.png" alt="Undo icon" width="24">
        </div>
         <!-- BOTÓN REDO -->
        <div
          @click="triggerRedo"
          v-b-tooltip.hover.buttom="$t('workspace.tooltip.forward')"
          class="icon-flipped"
          :class="{ 'disabled-icon': !canRedo }"
        >
          <img src="@/assets/imgs/undo.png" alt="Redo icon" width="24">
        </div>
        <!-- <div class="separator">|</div>
        <SaveStatusIndicator :status="saveStatus" /> -->
      </div>
    </div>
    <div class="right-rectangle" id="right-rectangle">
      <span class="text-black">{{ $t('workspace.categories.' + (selectedProject?.category || 'other')) }}</span>
      <div class="separator">|</div>  
      <b-dropdown
        id="help-dropdown"
        size="sm"
        variant="link"
        toggle-class="text-decoration-none dropdown-lang p-0"
        no-caret
        right
        @show="$root.$emit('bv::hide::tooltip', 'help-dropdown-btn')"
      >
        <template #button-content>
          <img
            id="help-dropdown-btn"
            src="@/assets/imgs/help-icon.png"
            class="img-fluid mt-0.5"
            alt="Help icon"
            width="23"
          >
        </template>
        <b-dropdown-item-button v-b-modal.modalShorcuts>{{ $t('workspace.help.diagram_shortcuts') }}</b-dropdown-item-button>
        <b-dropdown-item-button @click.prevent="launchTour">{{ $t('workspace.help.take_a_tour') }}</b-dropdown-item-button>
        <b-dropdown-item href="https://forms.gle/tpWeVrBJPNkpixnG7" target="_blank">{{ $t('workspace.help.leave_feedback') }}</b-dropdown-item>
      </b-dropdown>

      <!-- TOOLTIP -->
      <b-tooltip target="help-dropdown-btn" placement="buttom">
        {{ $t('workspace.help.title') }}
      </b-tooltip>
      <!-- MODAl -->
      <b-modal
        id="modalShorcuts"
        :title="$t('workspace.shortcuts.title')"
        hide-footer
        ok-only
      >
        <div class="d-flex justify-content-center">
          <ShorcutsComponent />
        </div>
      </b-modal>
      <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none dropdown-lang p-0" no-caret :title="$t('navbar.lang')">
        <template #button-content>
          <img src="@/assets/imgs/iconoIdiomasDark.svg" class="img-fluid mt-0.5" alt="Lang icon" width="23">
        </template>
        <b-dropdown-item-button @click.prevent="setLocale('pt')">PT</b-dropdown-item-button>
        <b-dropdown-item-button @click.prevent="setLocale('es')">ES</b-dropdown-item-button>
        <b-dropdown-item-button @click.prevent="setLocale('en')">EN</b-dropdown-item-button>
      </b-dropdown>
      <UserProfile v-if="isAuthenticated" class="p-0"/>
    </div>
  </nav>
</b-overlay>
  </div>
</template>
  <script>
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
  import { EventBus } from "@/main.js";
  import UserProfile from "@/views/user/UserProfile.vue";
  import ShorcutsComponent from '@/components/ShorcutsComponent.vue';
  import Swal from "sweetalert2";
  import practicalGuideData from "@/data/practicalGuideData";
  import { startTour } from '@/helpers/onDriverTour';
  import SaveStatusIndicator from '../SaveStatusIndicator.vue';
  
  export default {
    name: "ProjectNavbar",
    components: {
      UserProfile,
      ShorcutsComponent,
      SaveStatusIndicator
    },
    data() {
      return {
        hideCentralLogo: false,
        isProjectName: false,
        projectName: '', // Cambiado de String a string vacío
        practicalGuides: [],
        isLoading: false, // Agregar estado para el loading
        canUndo: false, 
        canRedo: false, 
      };
    },
    computed: {
      ...mapGetters('auth', ['isAuthenticated']),
      ...mapGetters('projects', ['selectedProject', 'saveStatus']),
    },
    watch: {
      "$route.fullPath": {
        handler: function(newPath) {
          // Verifica si la ruta actual es la página de perfil
          this.hideCentralLogo = newPath.includes("/create-project/") ||
            newPath.includes("/board") ||
            newPath.includes("/projects") ||
            newPath.includes("/academy") ||
            newPath.includes("/home");
          this.isProjectName = newPath.includes("/board/");
        },
        immediate: true,
      },
     '$route.params.activityId': {
    handler(newActivityId) {
      this.loadName(newActivityId);
    },
    immediate: true
  },
    },
    created() {
      this.loadProject();
      if (this.$route.params.activityId) {
        this.loadName(this.$route.params.activityId);
      }
      EventBus.$on('update-history-state', this.updateButtonStates);
    },
    beforeDestroy() {
      EventBus.$off('update-history-state', this.updateButtonStates);
    },
    methods: {
      ...mapMutations(['toggleSidebar', 'selectButton']),
      ...mapActions('auth', ['logout']),
      ...mapActions('projects', ['fetchProjectById','deselectProject', 'duplicateProjectWithData']),
      async loadProject() {
        const projectId = this.$route.params.id;
        if (projectId) {
          await this.fetchProjectById(projectId);
        } else {
          this.deselectProject();
        }
      },
      async loadName(activityId) {
  if (activityId) {
    try {
      const guides = await practicalGuideData.getAllGuides();
      const guide = guides.find(guide => guide.id === activityId);
      
      if (guide) {
        this.projectName = guide.name;
        console.log('Nombre de guía cargado:', this.projectName);
      } else {
        this.projectName = '';
        console.warn('No se encontró la guía con ID:', activityId);
      }
    } catch (error) {
      console.error('Error al cargar la guía:', error);
      this.projectName = '';
    }
  } else {
    this.projectName = '';
  }
},
      setLocale(locale) {
        if (this.$i18n.locale !== locale) {
          this.$i18n.locale = locale;
          this.$router.push({
            params: { lang: locale }
          });
        }
      },
      navigateToHome() {
        // Redirige a la vista de home
        if (this.$route.path != `/${this.$i18n.locale}/home`) {
          this.$router.push(`/${this.$i18n.locale}/home`);
        }
      },
      closeComponents() {
        // Cierra el b-modal si está abierto
        EventBus.$emit('close-modal');
        EventBus.$emit('close-sidebar');
        // Aquí puedes agregar más lógica para cerrar otros componentes si es necesario
      },
      async onLogout() {
        const result = await Swal.fire({
          title: this.$t('logout.title'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t('logout.yes'),
          cancelButtonText: this.$t('logout.no'),
        });
  
        if (result.isConfirmed) {
          try {
            await this.logout();
            this.$router.push(`/${this.$i18n.locale}/principal-page`);
          } catch (error) {
            console.error('Failed to logout:', error);
            Swal.fire(
              'Error',
              'Hubo un problema al cerrar la sesión. Por favor, inténtalo de nuevo.',
              'error'
            );
          }
        }
      },
  async duplicateCurrentProject() {
      if (this.selectedProject) {
        try {
          this.isLoading = true;
          
          // Duplicar el proyecto y obtener el nuevo ID
          const newProjectId = await this.duplicateProjectWithData(this.selectedProject);
          
          console.log('ID del nuevo proyecto:', newProjectId); // Debug
          
          if (newProjectId) {
            // Construir la nueva ruta
            const newRoute = `/${this.$i18n.locale}/board/${newProjectId}`;
            console.log('Redirigiendo a:', newRoute); // Debug
            
            const routeData = this.$router.resolve({
              path: newRoute
            });
            window.open(routeData.href, '_blank');
            
            // Mostrar mensaje de éxito
            Swal.fire({
              icon: 'success',
              title: this.$t('academy.success'),
              text: this.$t('academy.project-duplicated-success'),
              timer: 1500,
              showConfirmButton: false
            });
          } else {
            throw new Error('No se pudo obtener el ID del proyecto duplicado');
          }
        } catch (error) {
          console.error('Error al duplicar el proyecto:', error);
          Swal.fire({
            icon: 'error',
            title: this.$t('academy.error'),
            text: this.$t('academy.project-duplicated-error')
          });
        } finally {
          this.isLoading = false;
        }
      }
    },
      triggerUndo() {
        if (this.canUndo) {
          console.log('Navbar emitiendo evento: do-undo');
          EventBus.$emit('do-undo');
        }
      },
      triggerRedo() {
        if (this.canRedo) {
          console.log('Navbar emitiendo evento: do-redo');
          EventBus.$emit('do-redo');
        }
      },

      // NUEVO: Este método RECIBE el estado y actualiza 'data'
      updateButtonStates(states) {
        this.canUndo = states.canUndo;
        this.canRedo = states.canRedo;
      },
      launchTour() {
        startTour({ context: this, tourType: 'user'});
      },
    },
  };
  </script>
  <style>
.custom-navbar {
  display: flex;
  align-items: center;
  text-decoration: none;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

.left-rectangle {
  display: flex;
  align-items: center;
  gap: 1rem; /* Espacio entre la imagen y el texto */
  overflow: hidden;
}

.navigate {
  cursor: pointer;
}



  .navbar-btn .btn:focus, .btn.focus {
    box-shadow: 0 0 0 0;
  }
  </style>
  <style scoped>
  .navigate {
    cursor: pointer;
  }
  .padding-authenticated {
    padding-left: 120px;
  }
  
  .padding-unauthenticated {
    padding-left: 88px;
  }
  
  .navbar {
    display: flex;
    justify-content: space-between;
    padding: 0;
    gap: 1rem;
  }
  
  /* Rectángulo izquierdo */
  .left-rectangle {
    background-color: white;
    border-radius: 0.5rem;
    padding: 0.5rem 1rem;
    display: flex;
    align-items: center;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    min-width: 300px;
    height: 3rem;
  }
  
  
  .left-rectangle span {
    font-weight: 500;
  }
  
  /* Rectángulo derecho */
  .right-rectangle {
    background-color: white;
    border-radius: 0.5rem;
    padding-left: 1rem;
    display: flex;
    align-items: center;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    gap: 1rem;

  }
  
  /* Ajustes para los elementos dentro del rectángulo derecho */
  .navbar-btn {
    margin: 0;
    height: 100%;
    display: flex;
    align-items: center;
  }
  
  .dropdown-lang {
    padding: 0;
    margin: 0;
  }

.custom-nav {
  padding-left: 0;
  padding-right: 2.4rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 15px;
}



.img-fluid {
  max-width: 100%;
  height: auto;
}

.separator {
  color: #232323;
  font-weight: 500;
}
.undo-icon {
  cursor: pointer;
}
.icon-flipped {
  transform: scaleX(-1);
  cursor: pointer;
}
.disabled-icon {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>